import _createIconComponent from "./utils/createIconComponent";
const _createIconComponent2 = _interopRequireDefault(_createIconComponent);
import _react from "react";
const _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
const IconNotebookSolid = (0, _createIconComponent2.default)({
  content: _react2.default.createElement(
    "g",
    null,
    _react2.default.createElement("path", {
      d: "M17.1 18v1.4c0 1.2 1 2.2 2.2 2.2 1.2 0 2.3-1 2.3-2.3V18h-4.5zM21.6 6.3h-4.5v10.8h4.5V6.3zM21.5 5.4L19.8.3c-.1-.2-.3-.3-.4-.3-.1 0-.4.1-.5.3l-1.7 5.1h4.3zM2.7 1.8H1.4C.6 1.8 0 2.4 0 3.2v15.3c0 .7.6 1.3 1.4 1.3h1.4v-18h-.1zM14 1.8H3.6v18H14c.2 0 .4-.2.4-.4V2.3c0-.3-.2-.5-.4-.5zm-2.3 7.7c0 .2-.2.5-.5.5H5.9c-.2 0-.5-.2-.5-.5V6.8c0-.2.2-.5.5-.5h5.4c.2 0 .5.2.5.5v2.7h-.1z",
    })
  ),
  height: 22,
  width: 22,
});
IconNotebookSolid.displayName = "IconNotebookSolid";
const _default = IconNotebookSolid;
export { _default as default };
